import { NOTE_MENTION_CHIP_CLASS } from '../../../../utils/notesMentions';

/** Rich-HTML aus contentEditable (Chrome: &lt;div&gt;-Zeilen, b/i/u, Listen …). */
export const NOTE_HISTORY_RICH_CLASS =
  `break-words text-sm text-app-text-muted [&_p]:mb-2 [&_p:last-child]:mb-0 [&_div]:block [&_div]:mb-1.5 [&_div:last-child]:mb-0 [&_br]:block [&_ul]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-1.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5 [&_strong]:font-semibold [&_b]:font-semibold [&_em]:italic [&_i]:italic [&_u]:underline ${NOTE_MENTION_CHIP_CLASS}`;

export function sanitizeHistoryHtml(value: string): string {
  if (typeof window === 'undefined') return value;
  const parser = new DOMParser();
  const doc = parser.parseFromString(value, 'text/html');
  doc.querySelectorAll('script,style,iframe,object,embed').forEach((el) => el.remove());
  doc.querySelectorAll('*').forEach((el) => {
    for (const attr of Array.from(el.attributes)) {
      const name = attr.name.toLowerCase();
      const val = attr.value.trim().toLowerCase();
      if (name.startsWith('on')) el.removeAttribute(attr.name);
      if ((name === 'href' || name === 'src') && val.startsWith('javascript:')) el.removeAttribute(attr.name);
      if (name === 'data-mention-user-id' && !/^[0-9a-f-]{36}$/i.test(attr.value.trim())) {
        el.removeAttribute(attr.name);
      }
    }
    if (el.tagName.toLowerCase() === 'span' && el.getAttribute('data-mention-user-id')) {
      el.classList.add('mention');
      el.setAttribute('contenteditable', 'false');
    }
  });
  return doc.body.innerHTML;
}
